import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { kuunda } from '@/lib/kuunda';
import { useToast } from '@/features/ui/toast/useToast';

export function ChangePasswordPage() {
  const toast = useToast();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password.length < 10) {
      toast.error('Minimum 10 caractères.');
      return;
    }
    if (password !== confirm) {
      toast.error('Les mots de passe ne correspondent pas.');
      return;
    }
    setLoading(true);
    const { error: err } = await kuunda.auth.updateUser({ password });
    setLoading(false);
    if (err) toast.error(err.message);
    else {
      toast.success('Mot de passe mis à jour.');
      setPassword('');
      setConfirm('');
    }
  }

  return (
    <div className="u-page" style={{ maxWidth: 520 }}>
      <div className="u-hero">
        <div>
          <p className="u-subtitle">Minimum 10 caractères.</p>
        </div>
      </div>
      <section className="u-card">
        <form onSubmit={onSubmit}>
          <div className="field">
            <label>Nouveau mot de passe</label>
            <input type="password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="field">
            <label>Confirmation</label>
            <input type="password" required minLength={10} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? 'Enregistrement…' : 'Mettre à jour'}
          </button>
        </form>
        <p style={{ marginTop: '1rem', marginBottom: 0 }}>
          <Link to="/app/profil">← Retour profil</Link>
        </p>
      </section>
    </div>
  );
}
